import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "sonner";

import Header from "./components/Header";
import ProtectedRoute from "./components/ProtectedRoute";
import CookieBanner from "./components/CookieBanner";
import PromoBanner from "./components/PromoBanner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import CourseDetail from "./pages/CourseDetail";
import MyBookings from "./pages/MyBookings";
import InstructorDashboard from "./pages/InstructorDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Instructors, { InstructorProfile } from "./pages/Instructors";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancelled from "./pages/PaymentCancelled";
import LegalPage from "./pages/LegalPage";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import BecomeInstructor from "./pages/BecomeInstructor";
import ProfileSettings from "./pages/ProfileSettings";

function Shell() {
  const location = useLocation();
  const hideHeader = ["/login", "/register", "/forgot-password", "/reset-password", "/verify-email"].includes(location.pathname);
  return (
    <>
      {!hideHeader && <PromoBanner />}
      {!hideHeader && <Header />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/courses/:id" element={<CourseDetail />} />
        <Route path="/instructors" element={<Instructors />} />
        <Route path="/instructors/:id" element={<InstructorProfile />} />
        <Route path="/my-bookings" element={
          <ProtectedRoute roles={["client"]}><MyBookings /></ProtectedRoute>
        } />
        <Route path="/instructor" element={
          <ProtectedRoute roles={["instructor"]}><InstructorDashboard /></ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>
        } />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-cancelled" element={<PaymentCancelled />} />
        <Route path="/legal/:slug" element={<LegalPage />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/become-instructor" element={
          <ProtectedRoute roles={["client"]}><BecomeInstructor /></ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute><ProfileSettings /></ProtectedRoute>
        } />
      </Routes>
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
          <Toaster theme="dark" position="top-right" toastOptions={{
            className: "rounded-none border border-white/15 bg-[#0A0A0A] text-white",
          }} />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
